import {Root, Thumb} from '@radix-ui/react-switch';
import {ComponentProps} from 'react';
import {twMerge} from 'tailwind-merge';

type SwitchProps = ComponentProps<typeof Root>;

function Switch({className, ...props}: SwitchProps) {
  return (
    <Root
      data-slot="switch"
      className={twMerge(
        'peer group relative inline-flex shrink-0 items-center rounded-full',
        'h-[30px] w-[51px]',
        'border border-transparent bg-inactive outline-hidden transition-all',
        'after:absolute after:-inset-x-3 after:-inset-y-2 after:content-[""]',
        'focus-visible:border-ring focus-visible:ring focus-visible:ring-ring/50',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:bg-primary data-[state=unchecked]:bg-inactive',
        className
      )}
      {...props}
    >
      <Thumb
        data-slot="switch-thumb"
        className={twMerge(
          'pointer-events-none block size-[26px] rounded-full bg-white transition-transform',
          'data-[state=checked]:translate-x-[calc(100%-5px)]',
          'data-[state=unchecked]:translate-x-[2px]',
          'shadow-[0_3px_8px_0_rgba(0,0,0,0.10),0_1px_1px_0_rgba(0,0,0,0.01),0_3px_1px_0_rgba(0,0,0,0.03)]'
        )}
      />
    </Root>
  );
}

export default Switch;
